import React, { Component } from 'react';
import { loguear, cerrarSesion } from '../actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';

class Login extends Component {
  constructor(props){
    super(props);

    this.state = {
      email: "",
      password: ""
    }

    this.inputChangeListener = this.inputChangeListener.bind(this);
    this.submitLogin = this.submitLogin.bind(this);
  }

  submitLogin(event){
    event.preventDefault();
    this.props.loguear(this.state.email, this.state.password);
  }

  inputChangeListener(event){
    switch (event.target.name) {
      case "email":
        this.setState({ email: event.target.value });
        break;
      case "password":
        this.setState({ password: event.target.value });
        break;
      default: break;
    }
  }

  render(){
    if (this.props.usuario!==null) {
      if(this.props.usuario.session_token!==undefined && this.props.usuario.session_token!==null) {
        return (
          <Redirect push to="/cursos/1" />
        );
      }
    }
    return (
      <section id="login-section">
        <div className="login-container">
          <div className="form-box">
            <h3>Iniciar Sesión</h3>
            <form onSubmit={this.submitLogin}>
              <div className="input-group">
                <input
                  name="email"
                  type="text"
                  placeholder="Correo"
                  value={this.state.email}
                  onChange={this.inputChangeListener} />
                <input
                  name="password"
                  type="password"
                  placeholder="Contraseña"
                  value={this.state.password}
                  onChange={this.inputChangeListener} />
              </div>
              <div className="btn-group-vertical">
                <button
                  className="btn btn-info btn-block login"
                  type="submit" >
                  Iniciar Sesión
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    usuario: state.usuario
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    loguear: loguear,
    cerrarSesion: cerrarSesion
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/login.js